const Kategoriya2112 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 1-chorak<br />
                Mavzu: Unli va undosh tovushlar <br />
“Oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Nuqtalar o‘rniga so‘roqqa mos so‘zni topib yozing.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning lug‘at boyligini oshirish. <br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa <br />
            It vovillaydi, ot …(nima qiladi?). <br />
            (nima) akillaydi, mushuk …(nim qiladi?).
            <p><b>2-mashq.  Juftlikda ishlang. Bir undosh tovush bilan farqlanadigan so‘zlarni yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarni hamkorlikda ishlashga o‘rgatish, so‘zlar ma’nosini farqlash ko‘nikmalarini rivojlantirish. </p>
            <p><i>Mashg‘ulot davomiyligi:</i>2-3 daqiqa.</p>
            <ul>
                <li>qor</li>
                <li>qadr</li>
                <li>sabr</li>
                <li>bor</li>
            </ul>
            <p><b>3-mashq.  Juftlikda ishlang. Ikkinchi bo‘g‘ini ikki tovushdan iborat so‘zlarni alohida ustun shaklida yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarni hamkorlikda ishlashga o‘rgatish, so‘zlar ma’nosini farqlash ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>2-3 daqiqa.</p>
            <p>Havo, gitara, salqin, nonushta, chiroy, ko‘rk, bahor, kuz, qozon, kabob, navo, sichqon, baho.</p>
            <p><b>4-mashq. Nuqtalar o‘rniga to‘g‘ri harfni yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning imloviy ko‘nikmalarini oshirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>2-3 daqiqa.</p>
            <p>Sayro…i, oma…, me…r, …usayn, kito…ga, makta…ga. </p>
            <p><b>5-mashq. To‘g‘risini yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarni imloviy hushyorlikka chorlash.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>2-3 daqiqa.</p>
            <ul>
                <li>ozod</li>
                <li>obot</li>
                <li>singil</li>
                <li>kungil</li>
                <li>qalb</li>
                <li>xarorat</li>
            </ul>
            <p><b>6-mashq. Nuqtalar o‘rniga mos so‘zni tanlab yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning imloviy ko‘nikmalarini oshirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Do‘stlar davrani …(yayratadi, qizitadi). Bobom …(so‘zni, harfni, maqolni, hikoyani) maroq bilan ayta boshladi. Osmon podshosi – …(lochin, burgut, tuyaqush, bulbul).</p>
            <p><b>7-mashq.  Maqolning davomini yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning sintaktik ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Birlashgan – …,  … to‘zar.</p>
            <p>…  hurmatda bil, kichikni … bil.</p>
        </div>
    )
}
export default Kategoriya2112;